const addBreaklines = (string, number) => {
  let result = string;

  for (let i = 0; i < number; i++) {
    result += '\n';
  }

  return result;
};

/**
 * This function is used to create a multiline string from a JSON object.
 * @param {object} json - the JSON object to be transformed to multiline string.
 * @param {number} lineBreaks - represents the number of the line breaks
 * between each property.
 * @return {string} - the multiline string from the JSON object.
 * */
export default (json, lineBreaks = 1) => {
  let multilineString = '';

  const objectKeys = Object.keys(json || {});
  objectKeys.forEach((key, keyIndex) => {
    multilineString += `${key}: ${json[key]}`;
    if (keyIndex < objectKeys.length - 1) {
      multilineString = addBreaklines(multilineString, lineBreaks);
    }
  });

  return multilineString;
};
